;(function($) {

    var headerImmersive = $.fn.headerImmersive = function(options) {
        headerImmersive.elements = this;
        headerImmersive._apply();
        return this;
    };

    headerImmersive._apply = function() {

        var vpH = $.viewportH();

        if(this.elements != undefined){
            this.elements.each(function(){


                if(isMobile() || isTabletV()){
                    $(this).parent().css("height", 260);
                } else {
                    var newH = $.viewportW() / $(this).data('ratio');
                    if(newH > vpH){
                        newH = vpH*0.9;
                    }
                    $(this).parent().css("height", newH);
                }


            });
        }
        return this;
    };

    $(window).bind('load', function(event) {
        headerImmersive._apply();
    });

    $(window).bind('resize orientationchange', function(event) {
        headerImmersive._apply();
    });


})(jQuery);